module.exports = "<p>\n  page-not-found works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/page-not-found/page-not-found.component.html
// module id = ./src/app/view/page-not-found/page-not-found.component.html
// module chunks = main